import React, {useEffect, useRef} from 'react';

import classes from './Input.module.css';

const Input = ( props ) => {
    const focusInput = useRef();
    let inputElement = null;
    const inputClasses = [classes.InputElement];

    if (props.invalid && props.shouldValidate && props.touched) {
        inputClasses.push(classes.Invalid);
    }

    useEffect(() => {
        if (props.focusOnShow && focusInput.current) {
            focusInput.current.focus();
        }
    }, [props.focusOnShow]);

    switch ( props.elementType ) {
        case ( 'input' ):
            inputElement = <input
                ref={focusInput}
                className={inputClasses.join(' ')}
                {...props.elementConfig}
                value={props.value}
                required={props.required}
                onChange={props.changed} />;
            break;
        case ( 'textarea' ):
            inputElement = <textarea
                ref={focusInput}
                className={inputClasses.join(' ')}
                {...props.elementConfig}
                value={props.value}
                required={props.required}
                onChange={props.changed} />;
            break;
        case ( 'select' ):
            inputElement = (
                <select
                    ref={focusInput}
                    className={inputClasses.join(' ')}
                    value={props.value}
                    required={props.required}
                    onChange={props.changed}>
                    {props.elementConfig.options.map(option => (
                        <option key={option.value} value={option.value}>
                            {option.displayValue}
                        </option>
                    ))}
                </select>
            );
            break;
        default:
            inputElement = <input
                ref={focusInput}
                className={inputClasses.join(' ')}
                {...props.elementConfig}
                value={props.value}
                onChange={props.changed}
                required={props.required}
            />;
    }

    return (
        <div className={classes.Input}>
            <label className={classes.Label}>{props.label}</label>
            {inputElement}
        </div>
    );

};

export default Input;